import { Post, UserFull } from '@wellesley/openapi'
import { AppsRoutes } from '@wellesley/router'
import { getPostRoute } from 'helpers/routes'
import { getGroupChannelPostPath } from '@wellesley/group'

type GetFeedPostRouteProps = {
  feed: Post
  groupName?: string
  channel?: Pick<UserFull, 'groupUserName' | 'id'>
}

export const getFeedPostRoute = ({
  feed,
  groupName,
  channel,
}: GetFeedPostRouteProps): AppsRoutes => {
  const isAuthorChannel = feed.author.channel
  const feedGroupName = feed.author.groupName || feed.publisher?.groupName
  const authorGroupUserName =
    feed.author.groupUserName || feed.publisher?.groupUserName || ''
  const hasGroupChannel =
    (groupName && channel) ||
    ((isAuthorChannel || feedGroupName) && authorGroupUserName)

  if (hasGroupChannel) {
    return getGroupChannelPostPath({
      groupName: groupName || feedGroupName || '',
      channel: channel || {
        groupUserName: authorGroupUserName,
      },
      postId: feed.id,
    })
  }

  return getPostRoute(feed.author, feed.id)
}
